import { Component, Input } from '@angular/core'

@Component({
    selector: 'eb-cart-item-header',
    templateUrl: './eb-cart-item-header.component.html',
    styleUrls: ['./eb-cart-item-header.component.scss'],
    standalone: false
})
export class EbCartItemHeaderComponent {
  @Input() compact = false
  @Input() showPrice = true
  @Input() hideQuantity = false
}
